<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <div class="naplo-eszkozsor">
    <ion-item lines="none"><ion-label position="stacked">Időszak -tól</ion-label><ion-input type="date" [(ngModel)]="szuro.tol"></ion-input></ion-item>
    <ion-item lines="none"><ion-label position="stacked">-ig</ion-label><ion-input type="date" [(ngModel)]="szuro.ig"></ion-input></ion-item>
    <ion-item lines="none"><ion-label position="stacked">Partner</ion-label>
      <ion-select [(ngModel)]="szuro.partnerId" interface="popover">
        <ion-select-option value="">Mind</ion-select-option>
        <ion-select-option *ngFor="let p of partnerek" [value]="p.id">{{ p.nev }}</ion-select-option>
      </ion-select></ion-item>
    <ion-item lines="none"><ion-label position="stacked">Pénztár</ion-label>
      <ion-select [(ngModel)]="szuro.penztarId" interface="popover">
        <ion-select-option value="">Mind</ion-select-option>
        <ion-select-option *ngFor="let p of penztarak" [value]="p.id">{{ p.azonosito }} – {{ p.nev }}</ion-select-option>
      </ion-select></ion-item>
    <ion-button style="--background:var(--naplo)" (click)="szurest()"><ion-icon slot="start" name="funnel"></ion-icon> Szűrés</ion-button>
    <ion-button fill="clear" (click)="szuroTorles()">Törlés</ion-button>
    <ion-button fill="outline" color="success" (click)="export()"><ion-icon slot="start" name="download"></ion-icon> CSV</ion-button>
  </div>

  <div *ngIf="adat && !adat.sorok.length" class="ures"><ion-icon name="book-outline"></ion-icon> Nincs megjeleníthető tétel a szűrésnek megfelelően.</div>

  <div class="tabla-wrap" *ngIf="adat && adat.sorok.length">
    <table class="naplo-tabla">
      <thead>
        <tr>
          <th>#</th><th>Dátum</th><th>Bizonylat</th><th>Partner</th><th>Megjegyzés</th>
          <th class="num" *ngFor="let f of fooszlopFejlecek">{{ f }}</th>
          <th class="num">Bevétel</th><th class="num">Kiadás</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of adat.sorok">
          <td>{{ r.sorszam }}</td><td>{{ r.datum }}</td><td>{{ r.bizonylatszam }}</td><td>{{ r.partner_nev }}</td><td>{{ r.megjegyzes }}</td>
          <td class="num" *ngFor="let i of [1,2,3,4,5,6,7]">{{ r.oszlopok[i] ? (r.oszlopok[i] | number:'1.0-0') : '' }}</td>
          <td class="num">{{ r.bevetel ? (r.bevetel | number:'1.0-0') : '' }}</td>
          <td class="num">{{ r.kiadas ? (r.kiadas | number:'1.0-0') : '' }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5">Összesen (göngyölt)</td>
          <td class="num" *ngFor="let i of [1,2,3,4,5,6,7]">{{ adat.osszeg.oszlopok[i] | number:'1.0-0' }}</td>
          <td class="num">{{ adat.osszeg.bevetel | number:'1.0-0' }}</td>
          <td class="num">{{ adat.osszeg.kiadas | number:'1.0-0' }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="osszeg-sav" *ngIf="adat">
    <div class="item">Bevételek: <b>{{ adat.osszeg.bevetel | number:'1.0-0' }} Ft</b></div>
    <div class="item">Kiadások: <b>{{ adat.osszeg.kiadas | number:'1.0-0' }} Ft</b></div>
    <div class="item">Eredmény: <b>{{ adat.osszeg.eredmeny | number:'1.0-0' }} Ft</b></div>
  </div>
</ng-container>
